// series — the series list, flat view, series page, preview and player (sesja 09).
// Keys mirror ../pl/series.ts exactly; `locales-parity.test.ts` guards the pair.
export const series = {
  title: 'Edits',
  new: 'New series', select: 'Select series', selected: 'selected', selectedOf: 'Selected: {n} of {total}',
  allReady: 'Select finished ({n})', selectReady: 'Select finished ({n})',
  clear: 'Clear', more: 'Load more', shown: 'Showing {n} of {total}',
  seriesCount_one: '{n} series', seriesCount_few: '{n} series', seriesCount_many: '{n} series',
  editsCount_one: '{n} edit', editsCount_few: '{n} edits', editsCount_many: '{n} edits',
  number: 'series #{id}',
  remove: 'Delete series', removeSelected: 'Delete selected', removeTitle: 'Delete the selected series?',
  removeBody: 'Series: {series}. MP4 files: {files}. Size: {size}.',
  keep: 'Keep',
  actionError: 'This action could not be completed. Refresh the state and try again.',
  chunks: '{done} of {total} chunks',
  thumbPending: 'Generating thumbnail', thumbUnavailable: 'Thumbnail unavailable',
  preview: 'Preview edit {n}', position: 'edit {n} of {total}', previous: 'Previous edit', next: 'Next edit',
  play: 'Play', pause: 'Pause', seek: 'Playback position', volume: 'Volume', mute: 'Mute', unmute: 'Unmute',
  fullscreen: 'Full screen', playing: 'playing',
  escClose: 'close', arrowsNav: 'previous / next edit',
  previewFacts: { series: 'Series', track: 'Track', style: 'Style', packs: 'Clip packs', duration: 'Length', size: 'Size' },
  music: 'Track', packs: 'Clip packs', style: 'Style', status: 'Status', all: 'All',
  filterStatus: { done: 'Ready', rendering: 'In queue', failed: 'Error', queued: 'In queue' },
  moreFilters: 'More filters', filtersCount: 'Filters ({n})', removeFilter: 'Remove filter: {name}',
  fragment: 'Fragment', styles: 'Styles and edit counts', cost: 'Cost', created: 'Created', createdAt: 'created {date}',
  gems: 'Tokens: {n}', noResults: 'No edits match these filters.',
  errorBody: 'Your files and tokens are safe. Check your connection and try again.',
  resetFilters: 'Clear filters',
  variants: 'Make variants from these settings', retryFailed: 'Retry failed ({n} × {cost} tokens)',
  retryUnavailable: 'The settings for this edit are no longer available. Create a new series in the Generator.',
  priceLoading: 'The price list is still loading - the button turns on by itself once it arrives.',
  priceRefresh: 'Reload prices',
  zipPartial: 'Download ready · {n}',
  zipPickNone: 'Select the edits that should go into the download.',
  refundBack: 'Tokens returned',
  refundPending: 'settlement pending',
  zipPreparing: 'Preparing ZIP', zipDownloading: 'Downloading ZIP', zipHanded: 'Download handed to your browser.',
  zipCancel: 'Cancel download', zipDone: 'ZIP saved', unknownSize: 'size unknown',
  queuedAfter: 'In queue after edit {n}', queuedSlot: 'Waiting for a free slot',
  meanTime: 'Average finished edit time: {n} s', back: 'Back to Edits',
  hook: 'Hook',
  zipShort: 'Download ZIP ({n})', zipWithSize: 'Download ZIP ({n}) · {size}',
  zipFiles_one: 'Download ZIP · {n} file · {size}', zipFiles_few: 'Download ZIP · {n} files · {size}', zipFiles_many: 'Download ZIP · {n} files · {size}',
  readyOf_one: '{done} of {total} ready', readyOf_few: '{done} of {total} ready', readyOf_many: '{done} of {total} ready',
  gemsFormula_one: '{n} edit × {cost} = {total}', gemsFormula_few: '{n} edits × {cost} = {total}', gemsFormula_many: '{n} edits × {cost} = {total}',
  gemsWord_one: '{n} token', gemsWord_few: '{n} tokens', gemsWord_many: '{n} tokens',
  editsHeading: 'Edits', editsOrder: 'series order',
  retryFailed_one: 'Retry failed ({n} × {cost} token)',
  retryFailed_few: 'Retry failed ({n} × {cost} tokens)',
  retryFailed_many: 'Retry failed ({n} × {cost} tokens)',
  // ── session 30 (minimal language): Edits as the start screen ──────────────────
  downloadAll: 'Download all',
  sameSettings: 'Same settings',
  firstRunTitle: 'Start with a track',
  firstRunCta: 'Upload a track',
  errorTitle: 'Could not load your series.',
  selectMode: 'Select',
  selectedCount: 'Selected: {n}',
  selectedCountMax: 'Selected: {n} / {max}',
  downloadSelected_one: 'Download {n} file · {size}',
  downloadSelected_few: 'Download {n} files · {size}',
  downloadSelected_many: 'Download {n} files · {size}',
  downloadFailedToast: 'Some files could not be downloaded.',
  selectEdit: 'Select edit {n} from {series}',
  openEdit: 'Open edit',
  removeOneTitle: 'Delete this series?',
  // R5 (principle 8 + rule 34): ONE sentence of decision. The currency promise left
  // the window — a refund and its absence live in the ledger and the balance.
  removedToast: 'Series deleted.',
  // ── R5 (rule 31): the date a thing was generated ───────────────────────────
  dateToday: 'today {time}',
  dateYesterday: 'yesterday {time}',
  readyWithDate: '{ready} · {date}',
  removeFailedToast: 'The series could not be deleted.',
  retriedToast_one: 'Retried {n} edit · -{gems}',
  retriedToast_few: 'Retried {n} edits · -{gems}',
  retriedToast_many: 'Retried {n} edits · -{gems}',
  retryFailedToast: 'The edits could not be retried.',
}
